const hospitalInitState = {
    hospitals: [],
    pagination: {}
};

export default hospitalInitState;
